import { Box } from "@design-system/Layout/Box";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { PageContainer } from "@design-system/Layout/PageContainer";
import { useParams } from "react-router-dom";
import { useObjective } from "../data";
import { ExampleDrawer } from "./components/ExampleDrawer";
import { IndicatorSelectModal } from "./components/IndicatorSelectModal";
import { ObjectiveDefinition } from "./components/ObjectiveDefinition";
import { ObjectiveFooter } from "./components/ObjectiveFooter";
import { ObjectiveHeader } from "./components/ObjectiveHeader";
import { ObjectiveSkeleton } from "./components/Skeleton";
import { useObjectivesBreadcrumb } from "./useObjectivesBreadcrumb";
import { ObjectiveBody } from "./components/ObjectiveDetails";

export const ObjectivePage = () => {
    const { objective_id } = useParams();
    const { objective, isPending } = useObjective(objective_id);
    useObjectivesBreadcrumb();

    return (
        <PageContainer className="max-w-[832px] max-h-full overflow-y-hidden">
            <FlexRow className="h-full overflow-y-hidden" alignItems="start">
                <Box
                    className="grid grid-rows-[auto_1fr_auto] h-full overflow-y-hidden"
                    w="full"
                >
                    {isPending ? (
                        <ObjectiveSkeleton />
                    ) : (
                        objective && (
                            <>
                                <ObjectiveHeader objective={objective} />
                                <FlexCol
                                    gap="9"
                                    className="scroll-y-auto overflow-y-auto h-full"
                                >
                                    <ObjectiveDefinition
                                        objective={objective}
                                    />
                                    <ObjectiveBody objective={objective} />
                                </FlexCol>
                                <ObjectiveFooter objective={objective} />
                            </>
                        )
                    )}
                </Box>
            </FlexRow>
            {objective && <IndicatorSelectModal objective={objective} />}
            <ExampleDrawer />
        </PageContainer>
    );
};
